import React, { useState, useEffect } from "react";
// Chakra imports
import {
  HStack,
  VStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  FormControl,
  FormLabel,
  Select,
  Checkbox,
  Switch,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";// Chakra Icons
import { SettingsIcon } from "@chakra-ui/icons";
import { FaEye, FaCreditCard, FaWrench, FaCheckCircle, FaEdit, FaMoneyBillAlt, FaRegEdit } from "react-icons/fa";
// Custom components
import useGetOrders from "../../hooks/useGetOrders";
import Pagination from "../../views/Custom/Pagination";
import ViewOrder from "../../modals/ViewOrder";
import CreatePayment from "../../modals/CreatePayment";
import EditPayment from "../../modals/EditPayment";
import AddOrderService from "../../modals/AddOrderService";
import CompleteOrder from "../../modals/CompleteOrder";
import ViewPayment from "../../modals/ViewPayment"; 
import EditOrder from "../../modals/EditOrder";
import { useAuth } from "contexts/auth";


function OrdersTable({
  customerId = undefined, 
}) {

    const textColor = useColorModeValue("gray.700", "white");
    let navbarIcon = useColorModeValue("gray.500", "gray.200");

    const authUser = useAuth();
    const [ page, setPage ] = useState(1);
    const pageLimit = 10;

    const { isOpen: isOpenViewOrder, onOpen: onOpenViewOrder, onClose: onCloseViewOrder } = useDisclosure();
    const { isOpen: isOpenViewPayment, onOpen: onOpenViewPayment, onClose: onCloseViewPayment } = useDisclosure();
    const { isOpen: isOpenCreatePayment, onOpen: onOpenCreatePayment, onClose: onCloseCreatePayment } = useDisclosure();
    const { isOpen: isOpenEditPayment, onOpen: onOpenEditPayment, onClose: onCloseEditPayment } = useDisclosure();
    const { isOpen: isOpenAddService, onOpen: onOpenAddService, onClose: onCloseAddService } = useDisclosure();
    const { isOpen: isOpenComplete, onOpen: onOpenComplete, onClose: onCloseComplete } = useDisclosure();
    const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
    const [ orderData, setOrderData ] = useState(null);
    const [ paymentData, setPaymentData ] = useState(null);
    const [ viewPaymentId, setViewPaymentId ] = useState(null);
    const [ completed, setCompleted ] = useState(false);// null=All, false=ongoing, true=completed
    const [ visibleColumns, setVisibleColumns ] = useState({
      "Customer": true,
      "Vehicle": true,
      "Mechanics": true,
      "Receive Date": true,
      "Warranty Date": true,
      "Sub Total": true,
      "Discount": true,
      "Total": true,
      "Payments": true,
    });



    let { 
      orders, 
      totalOrders, 
      setGettingOrders, 
      gettingOrders, 
      gettingOrdersReqSuccess 
    } = useGetOrders({ 
      page, 
      limit: pageLimit,
      completed, 
      customerId,  
    });


    useEffect(() => {
      reloadTable();
    }, [page, completed]);
    
    const reloadTable = () => {
      // console.log(page, completed);
      setGettingOrders(true);
    }

    const onChangeVisibleColumn = (columnName, value) => {
      const tmp = {...visibleColumns};
      tmp[columnName] = value;
      setVisibleColumns(tmp);
      // console.log(columnName, value);
    }

    // console.log(`customerId: ${customerId}`);

    return ( 
        <Flex direction="column" w="100%">
          <Box>
            <Flex direction="row" w="100%">
              <HStack>
                <Text marginLeft={2}>Status</Text>
                <Select 
                  defaultValue={'Ongoing'}
                  onChange={(e) => {
                    if (e.target.value == 'All') {
                      setCompleted(null);
                    } else if (e.target.value == 'Ongoing') {
                      setCompleted(false);
                    } else if (e.target.value == 'Completed') {
                      setCompleted(true);
                    }
                  }}
                >
                  <option key="status-all" value="All">All</option>
                  <option key="status-ongoing" value="Ongoing">Ongoing</option>
                  <option key="status-completed" value="Completed">Completed</option>
                </Select>
              </HStack>
              <Box flex={1} alignSelf="center" textAlign="right">
                <Menu>
                  <MenuButton>
                    <SettingsIcon color={navbarIcon} w="24px" h="24px" />
                  </MenuButton>
                  <MenuList p="16px 8px" width="80px">
                    <Flex flexDirection="column">
                      { Object.keys(visibleColumns).map((key) => {
                          return (
                            <FormControl 
                              key={`menu-item-list-${key}`}
                              display="flex" 
                              alignItems="center" >
                              <FormLabel htmlFor={key} mb="0"
                              width="100%">
                                {key}
                              </FormLabel>
                              <Switch id={key} defaultChecked={visibleColumns[key]}
                                onChange={e => onChangeVisibleColumn(key, e.target.checked)}/>
                            </FormControl>
                          )
                        })
                      }
                    </Flex>
                  </MenuList>
                </Menu>
              </Box>
              
              
            </Flex>
          </Box>
          <Box 
            marginTop={2}
            flex={customerId != undefined ? undefined : "1"} 
            maxHeight={customerId != undefined ? "74vh" : undefined}
            overflowY={customerId != undefined ? "auto" : undefined}
          >
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" p={2} color="gray.400">
                  { visibleColumns["Customer"] 
                  ? <Th p={2} color="gray.400">Customer</Th>
                  : null }
                  { visibleColumns["Vehicle"] 
                    ? <Th p={2} color="gray.400">Vehicle</Th>
                    : null }
                  { visibleColumns["Mechanics"] 
                    ? <Th p={2} color="gray.400">Mechanics</Th>
                    : null }
                  { visibleColumns["Receive Date"] 
                    ? <Th p={2} color="gray.400">Receive Date</Th>
                    : null }
                  { visibleColumns["Warranty Date"] 
                    ? <Th p={2} color="gray.400">Warranty Date</Th>
                    : null }
                  { visibleColumns["Sub Total"] 
                    ? <Th p={2} color="gray.400">Sub Total</Th>
                    : null }
                  { visibleColumns["Discount"] 
                    ? <Th p={2} color="gray.400">Discount</Th>
                    : null }
                  { visibleColumns["Total"] 
                    ? <Th p={2} color="gray.400">Total</Th>
                    : null }
                  { visibleColumns["Payments"] 
                    ? <Th p={2} color="gray.400">Payments</Th>
                    : null }
                  <Th p={2} color="gray.400">Actions</Th>
                   
                </Tr>
              </Thead>
              <Tbody>
                {gettingOrders ? 
                  <Tr my=".8rem" >
                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                      <Progress isIndeterminate />
                    </Td>
                  </Tr>
                  : orders.map((o) => {
                    return (
                      <Tr my=".8rem" p={2} key={`order-row-${o.id}`}>
                        { visibleColumns["Customer"] 
                          ? <Td p={2}>
                              { o.customer.companyName 
                                ? <Text>{o.customer.companyName}</Text>
                                : <Text>{o.customer.firstName} {o.customer.lastName}</Text>
                              }
                              <Text>({o.customer.email})</Text>
                            </Td>
                          : null
                        }
                        { visibleColumns["Vehicle"] 
                          ? <Td  p={2}>
                              <Text>{o.carMake} {o.carType} {o.carYear}</Text>
                              <Text>Plate No: {o.carPlate}</Text>
                              <Text>Odo: {o.carOdometer}</Text>
                            </Td>
                          : null 
                        } 
                        { visibleColumns["Mechanics"] 
                          ? <Td  p={2}>
                              {o.mechanics 
                                ? o.mechanics.map((m, index) => {
                                    return <Box key={`m-box-${m.id}`}>
                                      {index > 0 ?? <br/>}
                                      {m.fullName}
                                    </Box>
                                  }) 
                                : ''
                              }
                            </Td>
                          : null 
                        }
                        { visibleColumns["Receive Date"] 
                          ? <Td  p={2}>{new Date(o.receiveDate).toLocaleString()}</Td>
                          : null 
                        }
                        { visibleColumns["Warranty Date"] 
                          ? <Td  p={2}>{new Date(o.warrantyEnd).toLocaleString()}</Td>
                          : null 
                        }
                        { visibleColumns["Sub Total"] 
                          ? <Td  p={2}>₱{Number(o.subTotal).toLocaleString()}</Td>
                          : null 
                        } 
                        { visibleColumns["Discount"] 
                          ? <Td  p={2}>₱{Number(o.discount).toLocaleString()}</Td>
                          : null 
                        } 
                        { visibleColumns["Total"] 
                          ? <Td  p={2}>₱{Number(o.total).toLocaleString()}</Td>
                          : null 
                        } 
                        { visibleColumns["Payments"] 
                          ? <Td  p={2}>
                              { o.payments.map((p, pIndex) => {
                                  return <Text 
                                      key={`payment-view-${p.id}`}
                                      p="0px" 
                                      bg="transparent" 
                                    >
                                    <Flex direction="row" cursor="pointer" align="center">
                                      { o.completed 
                                        ? null 
                                        : authUser.auth.role == 'manager'
                                          ? <Icon as={FaRegEdit} 
                                            me="6px" 
                                            p="0px" 
                                            bg="transparent" 
                                            title={`Edit Payment ₱${Number(p.amount).toLocaleString()}`}
                                            disabled={o.completed}
                                            onClick={o.completed 
                                              ? null 
                                              : () => {
                                              setPaymentData(p);
                                              onOpenEditPayment(true);
                                            }}
                                          />
                                          : null
                                      }
                                      <Text  
                                        as="u" 
                                        textColor={"blue"} 
                                        title="View Payment Details"
                                        onClick={() => {
                                          // console.log(o);
                                          // console.log(p);
                                          setOrderData(o);
                                          setViewPaymentId(p.id);
                                          onOpenViewPayment(true);
                                        }}
                                        >₱{Number(p.amount).toLocaleString()}</Text> 
                                    </Flex>
                                  </Text>
                                })
                              }
                            </Td>
                          : null
                        }
                        <Td  p={2}>
                          <Flex flexDirection="row">
                            
                            <Button 
                              key={`action-${o.id}-view-order`}
                              p="0px" bg="transparent" 
                              title="View Details"
                              onClick={() => {
                                setOrderData(o);
                                onOpenViewOrder(true);
                              }}
                            >
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaEye} me="2px" />
                              </Flex>
                            </Button>

                            {authUser.auth.role == 'manager'
                              ? <Button 
                                key={`action-${o.id}-add-payment`}
                                p="0px" bg="transparent" 
                                title="Add Payment"
                                disabled={o.completed}
                                onClick={() => {
                                  setOrderData(o);
                                  onOpenCreatePayment(true);
                                }}
                              >
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaCreditCard} me="2px" />
                              </Flex>
                            </Button>: null }


                          </Flex>
                          <Flex flexDirection="row">
                            {/* <Button 
                                key={`action-${o.id}-add-services`}
                                p="0px" bg="transparent" 
                                title="Add More Service"
                                disabled={o.completed}
                                onClick={() => {
                                  setOrderData(o);
                                  onOpenAddService(true);
                                }}
                              >
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaWrench} me="2px" />
                              </Flex>
                            </Button> */}

                              {authUser.auth.role == 'manager'
                              ? <Button 
                                key={`action-${o.id}-add-services`}
                                p="0px" bg="transparent" 
                                title="Edit Order"
                                disabled={o.completed}
                                onClick={o.completed 
                                  ? null 
                                  : () => {
                                  setOrderData(o);
                                  onOpenEdit(true);
                                }}
                              >
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaEdit} me="2px" />
                              </Flex>
                            </Button>: null }
                            
                            {authUser.auth.role == 'manager'
                              ? <Button 
                                key={`action-${o.id}-complete-order`}
                                p="0px" bg="transparent" 
                                title="Complete this Order"
                                disabled={o.completed}
                                onClick={o.completed 
                                  ? null 
                                  : () => {
                                  setOrderData(o);
                                  onOpenComplete(true);
                                }}
                              >
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaCheckCircle} me="2px" />
                              </Flex>
                            </Button> : null }
                          </Flex>
                        </Td>
                      </Tr>
                    );
                  })
                }
                
              </Tbody>
            </Table>
          </Box>
          <Spacer />
          { !gettingOrders 
            ? <Pagination 
              totalItems={totalOrders}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
            : null
          }

            <ViewOrder 
                isOpen={isOpenViewOrder}
                onClose={onCloseViewOrder}
                orderData={orderData}
            />

            {authUser.auth.role == 'manager'
            ? 
            <CreatePayment 
                isOpen={isOpenCreatePayment}
                onClose={onCloseCreatePayment}
                orderData={orderData}
                successCallback={reloadTable}
            />
            : null }

            {authUser.auth.role == 'manager'
              ? <EditPayment 
                isOpen={isOpenEditPayment}
                onClose={onCloseEditPayment}
                paymentData={paymentData}
                successCallback={reloadTable}
            />
            : null }

            {authUser.auth.role == 'manager'
              ? <ViewPayment 
                isOpen={isOpenViewPayment}
                onClose={onCloseViewPayment}
                orderData={orderData}
                paymentId={viewPaymentId}
            /> : null }

            {/* <AddOrderService 
                isOpen={isOpenAddService}
                onClose={onCloseAddService}
                orderData={orderData}
                successCallback={reloadTable}
            /> */}

            {authUser.auth.role == 'manager'
              ? <EditOrder 
                isOpen={isOpenEdit}
                onClose={onCloseEdit}
                orderData={orderData}
                successCallback={reloadTable}
            /> : null }

            {authUser.auth.role == 'manager'
              ? <CompleteOrder 
                isOpen={isOpenComplete}
                onClose={onCloseComplete}
                orderData={orderData}
                successCallback={reloadTable}
            /> : null }
        
        </Flex>
    )
}


export default OrdersTable;